import Icon from "components/Elements/Icon/Icon.tsx";
import React from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import Image from "components/Elements/Image/Image.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip";
import { useUser } from "contexts/userContext/userContext.js";

const FormBuilderFooterAndButton = ({
  detailsMode,
  formButtonsColor,
  setDetailsMode,
  formButtonTextColor,
  continueText,
  displayFooterLinks,
  linkFooters,
}) => {
  const { getTextByKey } = useContent();
  const { isPremium } = useUser();
  const RenderFooterLink = ({ item, i }) => {
    return i === linkFooters.length - 1 ? (
      <div key={i} className="div-link">
        <span>{item.FooterLinkTitle} </span>
      </div>
    ) : (
      <>
        <div className="div-link" key={i}>
          <span>{item.FooterLinkTitle}</span>
        </div>
        <div className="space">{" | "}</div>
      </>
    );
  };
  return (
    <>
      <div
        className={`continue-button ${
          detailsMode === "button-settings" ? "active" : ""
        }`}
        onClick={() => setDetailsMode("button-settings")}
      >
        <Tooltip
          id={"form-continue-tooltip"}
          tooltipTextKey="form-continue-tooltip"
          //hardPositioned
          top
        >
          <input
            style={{
              backgroundColor: formButtonsColor,
              color: formButtonTextColor,
            }}
            readOnly={true}
            type="button"
            value={continueText}
          />
        </Tooltip>
        <div className="edit" onClick={() => setDetailsMode("footer-links")}>
          <Icon name="pencil-alt-solid" />
        </div>
      </div>
      <div
        className={`footer-form ${displayFooterLinks ? "" : "hide-footer"} ${
          detailsMode === "footer-links" ? "active" : ""
        }`}
      >
        <div className="left-side-footer">
          <Image name="jumbomail-logo-black" alt="" title="" />
        </div>
        <div className="right-side-footer">
          {linkFooters &&
            linkFooters.map((item, i) => (
              <RenderFooterLink item={item} i={i} key={i} />
            ))}
          <div className="edit" onClick={() => setDetailsMode("footer-links")}>
            <Icon name="pencil-alt-solid" />
          </div>
        </div>
        <div className="add-footer-links">
          {isPremium() && (
            <div
              className="add-footer-links-container"
              onClick={() => setDetailsMode("footer-links")}
            >
              <div className="edit">
                <Icon name="plus" />
              </div>
              <span>{getTextByKey("add-footer-links")}</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FormBuilderFooterAndButton;
